module.exports = __webpack_public_path__ + "img/30.063945a0.jpg";